// Single source of truth for the page/panel slugs help articles can be
// scoped to, so HelpArticleEditor's selects can't offer a slug that no
// HelpButton anywhere in the app will ever open.

export const HELP_PAGES = [
  { value: '',             label: '(General / Help center only)' },
  { value: 'sessions',     label: 'Sessions (analysis view)' },
  { value: 'video-studio', label: 'Video Studio' },
  { value: 'leaderboard',  label: 'Leaderboard' },
  { value: 'progress',     label: 'Progress' },
  { value: 'search',       label: 'Search' },
  { value: 'report',       label: 'Session Report' },
  { value: 'channelstats', label: 'Channel Stats' },
  { value: 'upload',       label: 'Upload / session list' },
];

// Only relevant when page === 'sessions'.
export const HELP_PANELS = [
  { value: '',                label: '(Page-level, no specific panel)' },
  { value: 'speedtrace',      label: 'Speed Trace' },
  { value: 'gtrace',          label: 'G-Force Trace' },
  { value: 'timedeltatrace',  label: 'Time Delta' },
  { value: 'sectortimes',     label: 'Split Times' },
  { value: 'frictioncircle',  label: 'Friction Circle' },
  { value: 'scatterplot',     label: 'Scatter' },
  { value: 'metricspanel',    label: 'Corner Metrics' },
  { value: 'headtohead',      label: 'Head-to-Head' },
  { value: 'trackdifference', label: 'Track Difference' },
  { value: 'lap3d',           label: '3D View' },
  { value: 'channeltrace',    label: 'Channel Trace (generic)' },
  { value: 'powertrace',      label: 'Power Trace' },
  { value: 'trackmap',        label: 'Track Map' },
  { value: 'videopanel',      label: 'Video' },
  { value: 'videolayouteditor', label: 'Video Layout Editor' },
];
